module.exports = __webpack_public_path__ + "static/media/inst_im.fa5e7590.svg";